import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectData, BimCreateContractSubObjectMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';

import { bimCreateContractSubObjectGql } from '../BimContractStructureRequests';

interface IUseBimCreateContractSubObject {
    onClose: () => void;
    onSuccess: (item: BimContractObjectData) => void;
}

const requestId = 'bimCreateContractSubObject';

export const useBimCreateContractSubObject = (props: IUseBimCreateContractSubObject) => {
    const { onClose, onSuccess } = props;

    const [resetBimCreateContractSubObject] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimCreateContractSubObjectMutation>) => {
            resetBimCreateContractSubObject(undefined);
            if (depsVars?.payload?.bimCreateContractSubObject?.data) {
                onSuccess(depsVars?.payload?.bimCreateContractSubObject?.data);
            }
            onClose();
        },
        [onClose, onSuccess, resetBimCreateContractSubObject],
    );

    const [, , , bimCreateContractSubObjectRequest] = useRequest<BimCreateContractSubObjectMutation>({
        requestId,
        query: bimCreateContractSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return bimCreateContractSubObjectRequest;
};
